// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
 
.sign-container {
    text-align: center;
}

.sign-option-box {
    background-color: beige;
    margin: 20px;
    width:500px;
}

.sign-option-box .btn{
    background-color: white;
}

.oid4vp_container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.qrcode_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}

.certificateContainer{
    padding:1em 2em;
    max-height: 500px;
    overflow: auto;
}

.selectCertificate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2rem 0rem;
}

            .sw-theme-square > .nav .nav-link.active::before {
    background-color: #eb6823 !important;
    box-shadow: 0px 1px 7px 1px rgba(0, 0, 0, 0.3);
}                  

.sw-theme-square > .nav .nav-link.done::before {
    background-color: #cd815a !important;
}

.sw-theme-square > .nav .nav-link.active {
    color: #eb6823 !important;
    cursor: pointer;
}

.sw-theme-square > .nav .nav-link.done {
    color: #cd815a;
    cursor: pointer;
}

.sw .toolbar > .sw-btn {
    background-color: #eb6823;
    border: 1px solid #eb6823;
}`, "",{"version":3,"sources":["webpack://./src/user/sign/Sign.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;YAEY;IACR,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B","sourcesContent":["/*\r\n Copyright 2024 European Commission\r\n\r\n Licensed under the Apache License, Version 2.0 (the \"License\");\r\n you may not use this file except in compliance with the License.\r\n You may obtain a copy of the License at\r\n\r\n      https://www.apache.org/licenses/LICENSE-2.0\r\n\r\n Unless required by applicable law or agreed to in writing, software\r\n distributed under the License is distributed on an \"AS IS\" BASIS,\r\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n See the License for the specific language governing permissions and\r\n limitations under the License.\r\n */\r\n \r\n.sign-container {\r\n    text-align: center;\r\n}\r\n\r\n.sign-option-box {\r\n    background-color: beige;\r\n    margin: 20px;\r\n    width:500px;\r\n}\r\n\r\n.sign-option-box .btn{\r\n    background-color: white;\r\n}\r\n\r\n.oid4vp_container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n.qrcode_container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.certificateContainer{\r\n    padding:1em 2em;\r\n    max-height: 500px;\r\n    overflow: auto;\r\n}\r\n\r\n.selectCertificate {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 2rem 0rem;\r\n}\r\n\r\n            .sw-theme-square > .nav .nav-link.active::before {\r\n    background-color: #eb6823 !important;\r\n    box-shadow: 0px 1px 7px 1px rgba(0, 0, 0, 0.3);\r\n}                  \r\n\r\n.sw-theme-square > .nav .nav-link.done::before {\r\n    background-color: #cd815a !important;\r\n}\r\n\r\n.sw-theme-square > .nav .nav-link.active {\r\n    color: #eb6823 !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.sw-theme-square > .nav .nav-link.done {\r\n    color: #cd815a;\r\n    cursor: pointer;\r\n}\r\n\r\n.sw .toolbar > .sw-btn {\r\n    background-color: #eb6823;\r\n    border: 1px solid #eb6823;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
